$(document).ready(function () {
  const $gallery = $('media-gallery').first();

  if (!$gallery.length) return;

  const productTitle = (window.__productTitle || '').trim().toLowerCase();
  const $productSection = $gallery.closest('.shopify-section');
  let switchToken = 0;
  const preloadedColors = {};

  function getVariantPicker() {
    // The theme can re-render this element after a variant change, so resolve
    // it from the current section each time instead of keeping a stale node.
    return $productSection.find('variant-selects').first();
  }

  function normalize(str) {
    return (str || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getSelectedColor() {
    return normalize(
      getVariantPicker()
        .find('.product-form__input--swatch .swatch-input__input:checked')
        .first()
        .val()
    );
  }

  function isAlwaysVisibleAlt(altText) {
    const alt = normalize(altText);

    if (productTitle && alt === productTitle) return true;

    return false;
  }

  function getKnownColors() {
    const colors = [];
    getVariantPicker()
      .find('.product-form__input--swatch .swatch-input__input')
      .each(function () {
        const color = normalize(this.value);
        if (color && colors.indexOf(color) === -1) colors.push(color);
      });
    return colors.sort(function (a, b) {
      return b.length - a.length;
    });
  }

  function getThumbItems() {
    return $gallery.find('.thumbnail-list__item[data-target]');
  }

  function getMainItems() {
    return $gallery.find('.product__media-list .product__media-item[data-media-id]');
  }

  /**
   * 解析一张商品图属于哪个颜色。
   * @param {string} altText 图片 alt（可空）
   * @param {string} src 图片地址（alt 为空/等于标题时用文件名兜底猜色）
   * @returns {string} 归一化颜色名；'' 表示无法判断
   * 场景：PDP 切换颜色时过滤主图/缩略图（mainMatchesColor / thumbMatchesColor 调用）。
   * 顺序：#color_ 标记 → 描述性 alt 颜色前缀（最长匹配）→ 文件名 → 整串 alt。
   */
  function resolveMediaColor(altText, src) {
    const alt = (altText || '').toString().trim();
    const normalizedAlt = normalize(alt);
    const taggedColor = alt.match(/^#color[_:\s=-]+(.+)$/i);

    // Product media use the explicit "#color_Color name" convention. Read the
    // complete value after the marker so "Blue" never matches "Light Blue",
    // "Dusty Blue", "Navy Blue" or "Royal Blue".
    if (taggedColor) {
      return normalize(taggedColor[1].replace(/_/g, ' '));
    }

    // 2026-10 SEO 改造后的描述性 alt："Dusty Blue <款式名>"。取以颜色取值 + 空格开头
    // （或整串等于颜色）的最长匹配；getKnownColors 已按长度降序，"Dusty Blue" 先于 "Blue"。
    // alt 等于商品标题时不参与前缀匹配，保持原有「标题图」语义。
    if (alt && !(productTitle && normalizedAlt === productTitle)) {
      const prefixColor = getKnownColors().find(function (color) {
        return normalizedAlt === color || normalizedAlt.indexOf(color + ' ') === 0;
      });
      if (prefixColor) return prefixColor;
    }

    if (!alt || (productTitle && normalizedAlt === productTitle)) {
      let rawFilename = (src || '').split('?')[0].split('/').pop() || '';
      try {
        rawFilename = decodeURIComponent(rawFilename);
      } catch (error) {}
      const filename = normalize(rawFilename.replace(/[^a-z0-9]+/gi, ' '));
      const paddedFilename = ' ' + filename + ' ';
      const matchedColor = getKnownColors().find(function (color) {
        return paddedFilename.indexOf(' ' + color + ' ') !== -1;
      });
      if (matchedColor) return matchedColor;
      if (!alt) return '';
    }

    // Older products may use the color itself as the whole alt text. This is
    // intentionally an exact comparison; partial-word matching is not used.
    return normalize(alt);
  }

  function mediaIdFromThumb($thumb) {
    return $thumb.attr('data-target') || '';
  }

  function mainItemByMediaId(mediaId) {
    return getMainItems().filter('[data-media-id="' + mediaId + '"]');
  }

  function thumbMatchesColor($thumb, color) {
    const $img = $thumb.find('img');
    const altText = $img.attr('alt') || '';
    const mediaColor = resolveMediaColor(altText, $img.attr('src') || '');

    if (mediaColor) return mediaColor === color;

    return isAlwaysVisibleAlt(altText);
  }

  function mainMatchesColor($main, color) {
    const $img = $main.find('img');
    const altText = $img.attr('alt') || '';
    const mediaColor = resolveMediaColor(altText, $img.attr('src') || '');

    if (mediaColor) return mediaColor === color;

    return isAlwaysVisibleAlt(altText);
  }

  function mainImageEl($main) {
    return $main.find('.product__media img').get(0);
  }

  function whenImageReady(img, callback) {
    var settled = false;

    function finish() {
      if (settled) return;
      settled = true;
      callback();
    }

    var src = imageUrl(img);
    if (!src) {
      finish();
      return;
    }

    if (img && img.complete && img.naturalWidth > 0) {
      finish();
      return;
    }

    var loader = new Image();
    loader.onload = finish;
    loader.onerror = finish;
    loader.src = src;
    window.setTimeout(finish, 1200);
  }

  function preloadColor(color) {
    var key = normalize(color);
    if (!key || preloadedColors[key]) return;
    preloadedColors[key] = true;

    var $match = getMainItems().filter(function () {
      return mainMatchesColor($(this), key);
    }).first();
    var img = mainImageEl($match);
    if (!img) return;

    img.loading = 'eager';
    var loader = new Image();
    loader.src = img.currentSrc || img.src;
  }

  function firstMatchingMain(color) {
    var $match = $();
    getMainItems().each(function () {
      if (mainMatchesColor($(this), color)) {
        $match = $(this);
        return false;
      }
    });
    return $match;
  }

  function imageUrl(img) {
    return img ? img.currentSrc || img.src || '' : '';
  }

  function applyColorVisibility(color) {
    var $hero = getMainItems().filter('.is-active');
    getMainItems().each(function () {
      var $main = $(this);
      if ($main.is($hero)) {
        $main.removeClass('hidden').prop('hidden', false);
        return;
      }
      var shouldShow = mainMatchesColor($main, color);
      $main.toggleClass('hidden', !shouldShow).prop('hidden', !shouldShow);
    });

    getThumbItems().each(function () {
      var $thumb = $(this);
      var shouldShow = thumbMatchesColor($thumb, color);
      $thumb.toggleClass('hidden', !shouldShow).prop('hidden', !shouldShow);
    });

    refreshSliderCounter();
  }

  function syncColorThumbs(color, mediaId) {
    getThumbItems().each(function () {
      var $thumb = $(this);
      var shouldShow = thumbMatchesColor($thumb, color);
      $thumb.toggleClass('hidden', !shouldShow).prop('hidden', !shouldShow);
    });
    getThumbItems().find('button.thumbnail').removeAttr('aria-current');
    getThumbItems()
      .filter('[data-target="' + mediaId + '"]')
      .find('button.thumbnail')
      .attr('aria-current', 'true');
    refreshSliderCounter();
  }

  function commitActiveMedia(mediaId, color) {
    var mediaGallery = $gallery.get(0);
    var $targetMain = mainItemByMediaId(mediaId);
    var $targetThumb = getThumbItems().filter('[data-target="' + mediaId + '"]');
    var targetEl = $targetMain.get(0);

    if (!$targetMain.length) return;

    // Color switching is an in-place gallery update, so skip the page-entry
    // fade animation that would briefly render the next image almost transparent.
    $targetMain
      .removeClass('hidden scroll-trigger--offscreen')
      .addClass('scroll-trigger--cancel is-active')
      .prop('hidden', false);

    getMainItems().each(function () {
      var $main = $(this);
      if (this === targetEl) return;
      $main.removeClass('is-active');
      var shouldShow = !color || mainMatchesColor($main, color);
      $main.toggleClass('hidden', !shouldShow).prop('hidden', !shouldShow);
    });

    getThumbItems().each(function () {
      var $thumb = $(this);
      var shouldShow = !color || thumbMatchesColor($thumb, color);
      $thumb.toggleClass('hidden', !shouldShow).prop('hidden', !shouldShow);
    });

    getThumbItems().find('button.thumbnail').removeAttr('aria-current');
    $targetThumb.find('button.thumbnail').attr('aria-current', 'true');

    if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(mediaId, false);
    }

    if (targetEl && targetEl.parentElement) {
      targetEl.parentElement.scrollLeft = targetEl.offsetLeft;
    }

    refreshSliderCounter();
  }

  function refreshSliderCounter() {
    const viewer = $gallery.find('[id^="GalleryViewer"]').get(0);

    if (viewer && typeof viewer.resetPages === 'function') {
      viewer.resetPages();
    }
  }

  function filterImagesByColor(selectedColor, options) {
    const shouldUpdateActiveMedia = !options || options.updateActiveMedia !== false;
    const color = normalize(selectedColor);
    const $mainItems = getMainItems();
    const token = ++switchToken;

    if (!$mainItems.length) return;

    if (!color) {
      getThumbItems().removeClass('hidden').prop('hidden', false);
      $mainItems.removeClass('hidden').prop('hidden', false);
      refreshSliderCounter();
      return;
    }

    const $activeMain = $mainItems.filter('.is-active');
    const $nextMain = firstMatchingMain(color);
    const nextId = $nextMain.attr('data-media-id');
    const alreadyShowing =
      nextId &&
      imageUrl(mainImageEl($activeMain)) === imageUrl(mainImageEl($nextMain)) &&
      !$activeMain.hasClass('hidden') &&
      !$activeMain.prop('hidden');

    if (!shouldUpdateActiveMedia) {
      applyColorVisibility(color);
      return;
    }

    if (alreadyShowing || !nextId) {
      applyColorVisibility(color);
      if (nextId) syncColorThumbs(color, nextId);
      return;
    }

    var nextImg = mainImageEl($nextMain);
    whenImageReady(nextImg, function () {
      if (token !== switchToken) return;
      commitActiveMedia(nextId, color);
    });
  }

  $(document).on('click', 'media-gallery .thumbnail-list__item:not(.hidden) button.thumbnail', function () {
    const $thumb = $(this).closest('.thumbnail-list__item');
    const mediaId = mediaIdFromThumb($thumb);

    if (mediaId) {
      const token = ++switchToken;
      whenImageReady(mainImageEl(mainItemByMediaId(mediaId)), function () {
        if (token !== switchToken) return;
        commitActiveMedia(mediaId, getSelectedColor());
      });
    }
  });

  $(document).on('pointerenter', '.product-form__input--swatch .swatch-input__input + label, .product-form__input--swatch label', function () {
    if (!$productSection.get(0) || !$productSection.get(0).contains(this)) return;
    var input = this.control || (this.htmlFor ? document.getElementById(this.htmlFor) : null);
    if (!input) input = $(this).siblings('.swatch-input__input').get(0);
    if (input && input.value) preloadColor(input.value);
  });

  $(document).on('change', '.product-form__input--swatch .swatch-input__input', function () {
    if (!$productSection.get(0).contains(this)) return;

    const selectedColor = $(this).val();
    preloadColor(selectedColor);
    filterImagesByColor(selectedColor);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      filterImagesByColor(getSelectedColor(), { updateActiveMedia: false });
    });
  }

  filterImagesByColor(getSelectedColor());

  var idle = window.requestIdleCallback || function (cb) {
    window.setTimeout(cb, 200);
  };
  idle(function () {
    getVariantPicker()
      .find('.product-form__input--swatch .swatch-input__input')
      .each(function () {
        preloadColor(this.value);
      });
  });

  let lastWindowWidth = window.innerWidth;
  let resizeTimer;

  $(window).on('resize', function () {
    if (window.innerWidth === lastWindowWidth) return;

    lastWindowWidth = window.innerWidth;
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      filterImagesByColor(getSelectedColor(), { updateActiveMedia: false });
    }, 120);
  });
});
